import React, {PureComponent} from 'react';
import * as ReactGA from '../../../GA';
import TranslatedText from '../../../atoms/TranslatedText';
import MassSlide from './MassSlide';
import MassResult from './MassResult';
import MassBg from './mass-bg.jpg';
import i18n from '../../../locales/i18n';

import './MassTest.css';

const SLIDES = [
    {
        data: {
            label: 'high_definition_optics.mass_test.label_1',
            video: require('./mass-video-1.mp4'),
            poster: require('./mass-frame-1.jpg'),
        },
        component: MassSlide,
    },
    {
        data: {
            label: 'high_definition_optics.mass_test.label_2',
            video: require('./mass-video-2.mp4'),
            poster: require('./mass-frame-2.jpg'),
        },
        component: MassSlide,
    },
    {
        data: {
            label: 'high_definition_optics.mass_test.label_3',
            video: require('./mass-video-3.mp4'),
            poster: require('./mass-frame-3.jpg'),
        },
        component: MassSlide,
    },
    {
        data: {
            label: 'high_definition_optics.mass_test.label_4',
            img: require('./mass-frame-4.jpg'),
        },
        component: MassSlide,
    },
    {
        data: {
            labelOakley: 'high_definition_optics.mass_test.label_oakley',
            labelCompetitor:
                'high_definition_optics.mass_test.label_competitor',
            video: require('./mass-result.mp4'),
            poster: require('./mass-result-poster.jpg'),
        },
        component: MassResult,
    },
];

export default class MassTest extends PureComponent {
    state = {slide: 0};

    componentDidMount() {
        ReactGA.pageview(
            `${i18n.language}/HighDefinitionOptics/ImpactProtection/MassTest/${
                this.state.slide
            }`
        );
    }
    componentDidUpdate() {
        ReactGA.pageview(
            `${i18n.language}/HighDefinitionOptics/ImpactProtection/MassTest/${
                this.state.slide
            }`
        );
    }

    changeSlide = slide => {
        this.setState({slide: slide});
    };

    render() {
        const currentSlide = SLIDES[this.state.slide];
        const active = this.state.slide;
        const Component = currentSlide.component;

        const numbers = SLIDES.map((activeSlide, index) => (
            <div
                key={index}
                className={
                    active === index ? 'number number--active' : 'number'
                }
                onClick={() => this.changeSlide(index)}>
                {index + 1}
            </div>
        ));

        const style = {backgroundImage: `url(${MassBg})`};

        return (
            <article className="MassTest" style={style}>
                <div className="MassTest-top">
                    <h3 className="top-title">
                        <TranslatedText tag="high_definition_optics.mass_test.title" />
                    </h3>
                    <div className="top-subtitle">
                        <TranslatedText tag="high_definition_optics.mass_test.description" />
                    </div>
                </div>
                <Component
                    data={currentSlide.data}
                    number={this.state.slide}
                    key={active}
                />
                <div className="MassTest-number-indicator">
                    <div className="numbers">{numbers}</div>
                </div>
            </article>
        );
    }
}



// WEBPACK FOOTER //
// ./src/screens/highDefinitionOptics/MassTest/MassTest.js